module.exports = __webpack_public_path__ + "static/media/icon_leadership.d075d6d0.svg";